export default __webpack_public_path__ + "static/media/alte-birebaum.d7b7cfd6.png";